import styled from "@emotion/styled";
import {
  TypographyT22,
  TypographyT23,
  TypographyT24,
} from "Components/Common/Typography/index";
import React from "react";
import { Fragment } from "react";
import { ReactComponent as ExpandCircleDownOutlinedIcon } from "Icons/ExpandCircleDownOutlinedIcon.svg";
import FreightCalculationInfo from "./FreightCalculationInfo";
const InfoCard = (props) => {
  const {
    headerLabel = false,
    labelL1,
    labelL2,
    isActive = false,
    isIconEnable = false,
    isIconRotate = false,
    isleftPaddingEnabled = false,
    isTypeT1 = false,
    isTypeT2 = false,
    isClickable = false,
    onClickForInfoCard = () => {},
    handleIsExtraChargeAccordionOpen = () => {},
  } = props;
  return (
    <Fragment>
      <InfoCardWrapper isClickable={isClickable} onClick={onClickForInfoCard}>
        {!!isIconEnable && (
          <IconWrapper onClick={handleIsExtraChargeAccordionOpen}>
            <ExpandCircleDownOutlinedIcon
              width={"24px"}
              fill="#528AEA"
              transform={`${isIconRotate ? "rotate(180)" : ""}`}
            />
          </IconWrapper>
        )}
        {!!isleftPaddingEnabled && <LeftPadding />}

        <InfoCardContent>
          {!!headerLabel && <TypographyT22>{headerLabel}</TypographyT22>}
          {!!!headerLabel && (
            <TypographyT23
              color={!!isActive ? "#163760" : ""}
              fontWeight={!!isTypeT1 ? "500" : "600"}
              fontSize={!!isTypeT2 ? "20px" : "16px"}
            >
              {labelL1}
            </TypographyT23>
          )}
          {!!!headerLabel && (
            <TypographyT24 fontSize={!!isTypeT2 ? "20px" : "16px"}>
              {labelL2}
            </TypographyT24>
          )}
        </InfoCardContent>
      </InfoCardWrapper>
      {/* 
      {type === "T1" && <InfoCardT1 labelL1={labelL1} />}
      {type === "T2" && <InfoCardT1 />}
      {type === "T3" && <InfoCardT1 />}
      {type === "T4" && <InfoCardT1 />}
      {type === "T5" && <InfoCardT1 />}
      {type === "T6" && <InfoCardT1 />} */}
    </Fragment>
  );
};

export default InfoCard;

const InfoCardT1 = (props) => {
  const {} = props;
  return <Fragment></Fragment>;
};
const InfoCardT2 = (props) => {
  const {} = props;
  return <Fragment></Fragment>;
};
const InfoCardT3 = (props) => {
  const {} = props;
  return <Fragment></Fragment>;
};
const InfoCardT4 = (props) => {
  const {} = props;
  return <Fragment></Fragment>;
};
const InfoCardT5 = (props) => {
  const {} = props;
  return <Fragment></Fragment>;
};

const InfoCardWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 5px;
  border-bottom: 1px solid #c9cfd7;
  gap: 10px;
  &:last-of-type {
    border-bottom: 0px;
  }
  cursor: ${({ isClickable }) => (!!isClickable ? "pointer" : "default")};
`;
const InfoCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  width: 26px;
  max-height: 26px;
  max-width: 26px;
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  &:hover {
    background-color: #d4e3fc;
  }
`;
const LeftPadding = styled.div`
  padding-left: 25px;
`;
